var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseButtonImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-close-circle-outline",
    "data-name": "Icon ionic-ios-close-circle-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.319,
    height: 29.319,
    viewBox: "0 0 29.319 29.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_369566",
    "data-name": "Path 369566",
    d: "M23.066,21.51l-3.628-3.628,3.628-3.628A1.1,1.1,0,0,0,21.51,12.7l-3.628,3.628L14.254,12.7A1.1,1.1,0,0,0,12.7,14.254l3.628,3.628L12.7,21.51a1.064,1.064,0,0,0,0,1.556,1.093,1.093,0,0,0,1.556,0l3.628-3.628,3.628,3.628a1.105,1.105,0,0,0,1.556,0A1.093,1.093,0,0,0,23.066,21.51Z",
    transform: "translate(-3.221 -3.221)",
    fill: "#125bb2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_369567",
    "data-name": "Path 369567",
    d: "M18.035,5.348A12.681,12.681,0,1,1,9.063,9.063a12.6,12.6,0,0,1,8.972-3.714m0-1.973a14.66,14.66,0,1,0,14.66,14.66,14.657,14.657,0,0,0-14.66-14.66Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#125bb2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButtonImg);
export default __webpack_public_path__ + "static/media/CloseButtonImg.22212f36c0b447a2e5c0132994b75397.svg";
export { ForwardRef as ReactComponent };